import { filter, sortBy } from 'lodash';

/**
 * 读取 ProTable columnsState(localStorage)对列做过滤+排序。
 * - 过滤掉用户在列设置里隐藏(show === false)的列
 * - 按用户拖动后的 order 排序
 * 纯函数,无 React/JSX 依赖,可独立单测。
 *
 * 注:本函数原位于 src/utils/index.js,因 index.js 含 JSX 无法被单测直接 import,
 * 故抽到本纯文件;index.js 通过 re-export 保持所有现有调用方路径不变。
 */
export function loadExcelColumns(columns, localstorageKey) {
  let setting = null;
  try {
    setting = JSON.parse(localStorage.getItem(localstorageKey));
  } catch (error) {}

  const filteredColumns = filter(columns, col => {
    if (!col.key && !col.dataIndex) return false;
    if (!setting) return true;
    const key = col.key || col.dataIndex;
    if (setting[key]?.show === false) {
      return false;
    }
    return true;
  });
  const sortedColumns = sortBy(filteredColumns, col => {
    const key = col.key || col.dataIndex;
    return setting?.[key] ? setting[key].order : null;
  });
  return sortedColumns;
}
